import "core-js/stable";
import { registerBundle } from "scripts/lib/register-bundle.js";
registerBundle("vendors@layout.checkout@layout.password@layout.theme");
